import SearchBar from 'components/SearchBar/SearchBar';
import ConnectedSystemsWeb from 'features/Integrations/features/ConnectedSystems/index.web';

export default function ConnectedSystems() {
  return (
    <div className="d-flex flex-column gap-3 pt-3 h-100 min-h-0 overflow-hidden">
      {/* Header */}
      <div className="d-flex flex-column flex-md-row align-items-center justify-content-between flex-shrink-0">
        <div className="fs-4 fw-bold">Connected Systems</div>
        <SearchBar className="w-auto" />
      </div>
      {/* Content */}
      <div className="flex-grow-1 min-h-0 d-flex flex-column overflow-hidden">
        <ConnectedSystemsWeb />
      </div>
    </div>
  );
}
